<template>
  <div class="page-header-index-wide">
    <a-row :gutter="24" class="playground">
      <a-col :span="24" justify="end">
        <div
          style="
            width: 100%;
            background-color: #fff;
            display: flex;
            justify-content: end;
            align-items: center;
            padding: 10px 5px 10px 5px;
            border-radius: 10px;
          "
        >
          <a-input-search
            style="width: 500px"
            :placeholder="$t('点击选择区域')"
            v-model="checkedTopAreaName"
            readOnly
            @search="onSearchTopArea"
          >
            <a-button slot="enterButton" icon="search">{{ $t('选择') }}</a-button>
          </a-input-search>
          <span style="margin-left: auto">
            <span>{{ $t('更新时间') }}: {{ updateTime }}</span>
            <a-button type="link" @click="refreshAll" style="margin-left: 5px">{{ $t('刷新') }}</a-button>
          </span>
        </div>
      </a-col>
    </a-row>
    <div class="new-index-page">
    <a-row :gutter="[16, 8]" class="playground">
      <a-col :sm="24" :md="12" :xl="6" class="playground">
        <chart-card
          :loading="loading"
          :title="$t('水表激活数')"
          :info="$t('当前水表激活总数')"
          :total="meterInfo.meterTotalCount + ''"
        >
          <a-tooltip :title="$t('指标说明')" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <!--
          <div><mini-area /></div>
          -->
          <div slot="content">
            <a-row :gutter="[16, 0]">
              <a-col :span="12">
                <a-card class="litte-card" :body-style="cardBodyStyle">
                  <div class="card-body-div">
                    <span class="info-text">{{ $t('欠压数') }}</span>
                    <a @click="skipMeterAbnormalPage(1)" class="info-num">{{ meterInfo.meterBatteryFaultCount }}</a>
                  </div>
                </a-card>
              </a-col>
              <a-col :span="12">
                <a-card class="litte-card" :body-style="cardBodyStyle">
                  <div class="card-body-div">
                    <span class="info-text">{{ $t('磁干扰数') }}</span>
                    <a @click="skipMeterAbnormalPage(2)" class="info-num">{{ meterInfo.meterMagicFaultCount }}</a>
                  </div>
                </a-card>
              </a-col>
            </a-row>

            <a-row :gutter="[16, 0]">
              <a-col :span="24">
                <a-card class="litte-card" :body-style="cardBodyStyle">
                  <div class="card-body-div">
                    <span class="info-text">{{ $t('阀门故障数') }}</span>
                    <a @click="skipMeterAbnormalPage(3)" class="info-num"> {{ meterInfo.meterValveFaultCount }}</a>
                  </div>
                </a-card>
              </a-col>
            </a-row>

            <a-row :gutter="[16, 0]">
              <a-col :span="24">
                <a-card class="litte-card" :body-style="cardBodyStyle">
                  <div class="card-body-div">
                    <span class="info-text">{{ $t('故障率') }}</span>
                    <a @click="skipMeterAbnormalPage(0)" class="info-num">{{ meterInfo.meterFaultPercent }}%</a>
                  </div>
                </a-card>
              </a-col>
            </a-row>
          </div>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="18" :style="{ marginBottom: '10px' }" class="playground">
        <chart-card
          :loading="loading"
          :title="$t('建档数/供水统计')"
          :total="deviceCount.totalMeterCount | NumberFormat"
          :needNum="false"
        >
          <!-- <div>
            <trend flag="" style="margin-right: 16px">
              <span slot="term">昨日建档数</span>
              {{ deviceCount.yesterdayAddMeterCount }}
            </trend>
            <trend flag="" style="margin-right: 16px">
              <span slot="term">今日建档数</span>
              {{ deviceCount.addMeterCount }}
            </trend>
          </div>
          <template slot="footer"><span style="color: #fff">f </span></template> -->
          <div slot="content" style="height: 100%; display: flex; flex-direction: column">
            <a-row :gutter="[16, 8]" style="height: 45%; margin-bottom: 8px">
              <!-- <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '10px' }">
        <chart-card :loading="loading" title="本年度总供水量" :total="useList.waterUseYear+'m³'">
          <a-tooltip title="指标说明" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <trend flag="" style="margin-right: 16px;">
              <span slot="term">上月</span>
              {{useList.waterUseLastMonth}}m³
            </trend>
            <trend flag="">
              <span slot="term">本月</span>
              {{useList.waterUseCurMonth}}m³
            </trend>
          </div>
          <template slot="footer">
            <span style="color: #fff">f </span>

          </template>
        </chart-card>
      </a-col> -->
              <a-card
                :bodered="false"
                style="height: 100%; background: #00a2ff; border-radius: 8px"
                :body-style="{ height: '100%' }"
              >
                <a-col :span="6" style="height: 100%">
                  <div class="white-center-big">
                    <div class="image-wrapper_7 flex-col">
                    <img
                      class="image_9"
                      referrerpolicy="no-referrer"
                      :src="require('@/assets/shuidi2.png')"
                      style="width: 53px; height: 64px; position: absolute; top: 0; left: 90px; z-index: 98; margin: 0 0 0 0"
                    />
                    <img
                      class="image_10"
                      referrerpolicy="no-referrer"
                      :src="require('@/assets/shuidi2.png')"
                      style=" width: 79px; height: 96px;position: absolute; top: 0; left: 120px; z-index: 99; margin: 0 0 0 0"
                    />
                    </div>
                  </div>
                </a-col>

                <a-col :span="6" style="height: 100%">
                  <div class="white-center-big">
                    <div class="white-num">{{ useList.waterUseYear }}m³</div>
                    <br />
                    <div class="white-info">{{ $t('本年度总供水量') }}</div>
                  </div>
                </a-col>
                <a-col :span="6" style="height: 100%">
                  <div class="white-center-big">
                    <div class="white-num">{{ useList.waterUseLastMonth }}m³</div>
                    <br />
                    <div class="white-info">{{ $t('上月') }}</div>
                  </div>
                </a-col>
                <a-col :span="6" style="height: 100%">
                  <div class="white-center-big">
                    <div class="white-num">{{ useList.waterUseCurMonth }}m³</div>
                    <br />
                    <div class="white-info">{{ $t('本月') }}</div>
                  </div>
                </a-col>
              </a-card>
            </a-row>
            <a-row :gutter="[16, 8]" style="height: 45%">
              <a-card
                :bodered="false"
                style="height: 100%; background: #00BAF0; border-radius: 8px"
                :body-style="{ height: '100%' }"
              >
                <a-col :span="6" style="height: 100%">
                  <div class="white-center-big">
                    <img class="image_9" referrerpolicy="no-referrer" :src="require('@/assets/jiandan.png')" />
                  </div>
                </a-col>

                <a-col :span="6" style="height: 100%">
                  <div class="white-center-big">
                    <div class="white-num">{{ deviceCount.totalMeterCount | NumberFormat }}</div>
                    <br />
                    <div class="white-info">{{ $t('建档总数') }}</div>
                  </div>
                </a-col>
                <a-col :span="6" style="height: 100%">
                  <div class="white-center-big">
                    <div class="white-num">{{ deviceCount.yesterdayAddMeterCount }}</div>
                    <br />
                    <div class="white-info">{{ $t('昨日建档数') }}</div>
                  </div>
                </a-col>
                <a-col :span="6" style="height: 100%">
                  <div class="white-center-big">
                    <div class="white-num">{{ deviceCount.addMeterCount }}</div>
                    <br />
                    <div class="white-info">{{ $t('今日建档数') }}</div>
                  </div>
                </a-col>
              </a-card>
            </a-row>
          </div>
        </chart-card>
      </a-col>
    </a-row>
    <a-row :gutter="[16, 8]" class="playground">
      <a-col :sm="24" :md="12" :xl="6" class="playground">
        <chart-card :loading="loading" :title="$t('设备运行分析')" :total="upPercent.threeUpPercent + '%'" :info="$t('综合上报率')">
          <a-tooltip :title="$t('指标说明')" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <!-- <div>
            <trend flag="" style="margin-right: 16px">
              <span slot="term">近三日上报率</span>
              {{ upPercent.threeUpPercent }}%
            </trend>
            <trend flag="">
              <span slot="term">近七日上报率</span>
              {{ upPercent.sevenUpPercent }}%
            </trend>
          </div>
          <template slot="footer"
            >开阀 <span>{{ fkStatusTotal.meterValveOpenCount }}</span> 关阀
            <span>{{ fkStatusTotal.meterValveCloseCount }}</span></template
          > -->
          <div slot="content">
            <a-row :gutter="[16, 0]">
              <a-col :span="12">
                <a-card class="litte-card" :body-style="cardBodyStyle">
                  <div class="card-body-div">
                    <span class="info-text">{{ $t('开阀') }}</span>
                    <a class="info-num">{{ fkStatusTotal.meterValveOpenCount }}</a>
                  </div>
                </a-card>
              </a-col>
              <a-col :span="12">
                <a-card class="litte-card" :body-style="cardBodyStyle">
                  <div class="card-body-div">
                    <span class="info-text">{{ $t('关阀') }}</span>
                    <a class="info-num">{{ fkStatusTotal.meterValveCloseCount }}</a>
                  </div>
                </a-card>
              </a-col>
            </a-row>

            <a-row :gutter="[16, 0]">
              <a-col :span="24">
                <a-card class="litte-card" :body-style="cardBodyStyle">
                  <div class="card-body-div">
                    <span class="info-text">{{ $t('近三日上报率') }}</span>
                    <a class="info-num"> {{ upPercent.threeUpPercent }} %</a>
                  </div>
                </a-card>
              </a-col>
            </a-row>

            <a-row :gutter="[16, 0]">
              <a-col :span="24">
                <a-card class="litte-card" :body-style="cardBodyStyle">
                  <div class="card-body-div">
                    <span class="info-text">{{ $t('近七日上报率') }}</span>
                    <a class="info-num">{{ upPercent.sevenUpPercent }} %</a>
                  </div>
                </a-card>
              </a-col>
            </a-row>
          </div>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="18">
        <a-col :span="12">
        <chart-card :loading="loading" :bordered="false" :title="$t('近一年月用水统计')" :needNum="false">
          <!--
          <a-tabs default-active-key="1" size="large" :tab-bar-style="{marginBottom: '10px', paddingLeft: '16px'}">
            <a-tab-pane key="1" tab="近一年月用水/缴费统计" style="padding: 24px;height: 300px">
              <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                <bar-multid title="近一年月用水/缴费统计" :dataSource="jhjgData" :fields="jhjgFields" :style="{ padding: '0 0 0px 0px' }"></bar-multid>
              </a-col>
            </a-tab-pane>
            
            <a-tab-pane key="2" tab="各类用户近半年用水统计" force-render>
              <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                <bar-multid title="各类用户近半年用水统计" :dataSource="jhjgnData" :fields="jhjgnFields" :style="{ padding: '0 0 0px 0px' }"></bar-multid>
              </a-col>
            </a-tab-pane>
            
          </a-tabs>
          -->
          <div slot="content" style="height: 300px">
            <Echart ref="option4" :options="option4" style="height: 100%"> </Echart>
          </div>
        </chart-card>
        </a-col>
        <a-col :span="12">
          
        <chart-card :loading="loading" :bordered="false" :title="$t('近一年月缴费统计')" :needNum="false">
          <!--
          <a-tabs default-active-key="1" size="large" :tab-bar-style="{marginBottom: '10px', paddingLeft: '16px'}">
            <a-tab-pane key="1" tab="近一年月用水/缴费统计" style="padding: 24px;height: 300px">
              <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                <bar-multid title="近一年月用水/缴费统计" :dataSource="jhjgData" :fields="jhjgFields" :style="{ padding: '0 0 0px 0px' }"></bar-multid>
              </a-col>
            </a-tab-pane>
            
            <a-tab-pane key="2" tab="各类用户近半年用水统计" force-render>
              <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                <bar-multid title="各类用户近半年用水统计" :dataSource="jhjgnData" :fields="jhjgnFields" :style="{ padding: '0 0 0px 0px' }"></bar-multid>
              </a-col>
            </a-tab-pane>
            
          </a-tabs>
          -->
          <div slot="content" style="height: 300px">
            <Echart ref="option5" :options="option5" style="height: 100%"> </Echart>
          </div>
        </chart-card>
        </a-col>
      </a-col>
    </a-row>

    <a-row :gutter="[16, 8]" class="playground">
      <a-col :sm="24" :md="12" :xl="6" class="playground">
        <ChartCard
          :loading="loading"
          :bordered="false"
          :title="$t('营收分析')"
          :body-style="{ height: '333px' }"
          :needNum="false"
        >
          <!--
          <a-tabs default-active-key="1" size="large" :tab-bar-style="{marginBottom: '10px', paddingLeft: '16px'}">
            <a-tab-pane key="1" tab="营收分析" style="display: flex;height: 300px;padding: 24px;">
              <a-col :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
                <pie title="日分析"  :dataSource="DayPieData" :fields="DayPieFields" :style="{ padding: '0 0 0px 0px' }" />
              </a-col>
              <a-col :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
                <pie title="月分析"  :dataSource="MonthPieData" :fields="MonthPieFields" :style="{ padding: '0 0 0px 0px' }" />
              </a-col>
              -->
          <!--
              <div style="width:50%;height: 100%">
                <Echart ref="option" :options="option" style="height: 100%"></Echart>
              </div>
              <div style="width:50%;height: 100%">
                  <Echart ref="option2" :options="option2" style="height: 100%"></Echart>
              </div>
            </a-tab-pane>
          </a-tabs>
          -->
          <div slot="content">
            <a-row :gutter="[16, 8]">
              <a-col :span="8"> </a-col>
              <a-col :span="8"> <div class="info-text">{{ $t('营收金额') }}</div> </a-col>
              <a-col :span="8"> <div class="info-text">{{ $t('交易笔数') }}</div> </a-col>
            </a-row>
            <a-row :gutter="[16, 8]">
              <a-card :bodered="false" class="litte-card" :body-style="cardBodyStyle">
                <div class="card-body-div">
                  <a-col :span="8"> <div class="info-text start-title">{{ $t('昨日') }}</div></a-col>
                  <a-col :span="8">
                    <div class="font-20 info-num" style="color: #000">¥ {{ DayPayData.yesterdayPaySum }}</div>
                  </a-col>
                  <a-col :span="8">
                    <div class="font-20 info-num" style="color: #000">{{ DayPayData.yesterdayPayCount }}</div>
                  </a-col>
                </div>
              </a-card>
            </a-row>
            <a-row :gutter="[16, 8]">
              <a-card :bodered="false" class="litte-card" :body-style="cardBodyStyle">
                <div class="card-body-div">
                  <a-col :span="8"> <div class="info-text start-title">{{ $t('今日') }}</div></a-col>
                  <a-col :span="8">
                    <div class="font-20 info-num" style="color: #000">¥ {{ DayPayData.curDayPaySum }}</div>
                  </a-col>
                  <a-col :span="8">
                    <div class="font-20 info-num" style="color: #000">{{ DayPayData.curDayPayCount }}</div>
                  </a-col>
                </div>
              </a-card>
            </a-row>
            <a-row :gutter="[16, 8]">
              <a-card :bodered="false" class="litte-card" :body-style="cardBodyStyle">
                <div class="card-body-div">
                  <a-col :span="8"><div class="info-text start-title">{{ $t('上月') }}</div></a-col>
                  <a-col :span="8">
                    <div class="font-20 info-num" style="color: #000">¥ {{ MonthPayData.lastMonthPaySum }}</div>
                  </a-col>
                  <a-col :span="8">
                    <div class="font-20 info-num" style="color: #000">{{ MonthPayData.lastMonthPayCount }}</div>
                  </a-col>
                </div>
              </a-card>
            </a-row>
            <a-row :gutter="[16, 8]">
              <a-card :bodered="false" class="litte-card" :body-style="cardBodyStyle">
                <div class="card-body-div">
                  <a-col :span="8"><div class="info-text start-title">{{ $t('本月') }}</div></a-col>
                  <a-col :span="8">
                    <div class="font-20 info-num" style="color: #000">¥ {{ MonthPayData.curMonthPaySum }}</div>
                  </a-col>
                  <a-col :span="8">
                    <div class="font-20 info-num" style="color: #000">{{ MonthPayData.curMonthPayCount }}</div>
                  </a-col>
                </div>
              </a-card>
            </a-row>
          </div>

          <!-- <div style="height: calc(100% - 35px); width: 100%" class="flex flex-column">
              <div style="height: 25%; align-items: center" class="flex">
                <a-col :span="6"> 昨日 </a-col>
                <a-col :span="9">
                  <span class="font-20" style="color: #000">¥ {{ DayPayData.yesterdayPaySum }}</span>
                </a-col>
                <a-col :span="9">
                  <span class="font-20" style="color: #000">{{ DayPayData.yesterdayPayCount }}</span>
                </a-col>
              </div>
              <div style="height: 25%; align-items: center" class="flex">
                <a-col :span="6"> 今日 </a-col>
                <a-col :span="9">
                  <span class="font-20" style="color: #000">¥ {{ DayPayData.curDayPaySum }}</span>
                </a-col>
                <a-col :span="9">
                  <span class="font-20" style="color: #000">{{ DayPayData.curDayPayCount }}</span>
                </a-col>
              </div>
              <div style="height: 25%; align-items: center" class="flex">
                <a-col :span="6"> 上月 </a-col>
                <a-col :span="9">
                  <span class="font-20" style="color: #000">¥ {{ MonthPayData.lastMonthPaySum }}</span>
                </a-col>
                <a-col :span="9">
                  <span class="font-20" style="color: #000"> {{ MonthPayData.lastMonthPayCount }}</span>
                </a-col>
              </div>
              <div style="height: 25%; align-items: center" class="flex">
                <a-col :span="6"> 本月 </a-col>
                <a-col :span="9">
                  <span class="font-20" style="color: #000">¥ {{ MonthPayData.curMonthPaySum }}</span>
                </a-col>
                <a-col :span="9">
                  <span class="font-20" style="color: #000">{{ MonthPayData.curMonthPayCount }}</span>
                </a-col>
              </div>
            </div> -->
        </ChartCard>
      </a-col>
      <a-col :sm="24" :md="12" :xl="18" class="playground">
        <chart-card :loading="loading" :bordered="false" :title="$t('各区域近一年用水分析')" :needNum="false">
          <!--
          <line-chart-multid :dataSource="areaData" :fields="areaFields" :style="{ padding: '0 0 0px 0px' }"></line-chart-multid>
          -->

          <div slot="action">
            <a-input-search
              style="width: 500px"
              :placeholder="$t('点击选择区域')"
              v-model="checkedAreaNameString"
              readOnly
              @search="onSearchArea"
            >
              <a-button slot="enterButton" icon="search">{{ $t('选择') }}</a-button>
            </a-input-search>
          </div>

          <div style="height: 300px; width: 100%" slot="content">
            <Echart
              ref="option3"
              :options="option3"
              style="height: 100%"
              @legendselectchanged="legendselectchanged"
            ></Echart>
          </div>
        </chart-card>
      </a-col>
    </a-row>
  </div>
    <area-window ref="areaWindow" @ok="modalAreaFormOk" :checkStrictly="true"></area-window>
    <area-select-window ref="areaSelectWindow" @ok="modalAreaSelectFormOk" :checkStrictly="true"></area-select-window>
  </div>
</template>

<script>
import ChartCard from '@/components/ChartCard'
import ACol from 'ant-design-vue/es/grid/Col'
import ATooltip from 'ant-design-vue/es/tooltip/Tooltip'
import MiniArea from '@/components/chart/MiniArea'
import MiniBar from '@/components/chart/MiniBar'
import MiniProgress from '@/components/chart/MiniProgress'
import RankList from '@/components/chart/RankList'
import Bar from '@/components/chart/Bar'
import LineChartMultid from '@/components/chart/LineChartMultid'
import HeadInfo from '@/components/tools/HeadInfo.vue'

import Trend from '@/components/Trend'
import { getLoginfo, getVisitInfo } from '@/api/api'

import BarMultid from '@/components/chart/BarMultid'
import Pie from '@/components/chart/Pie'

import { putAction } from '@/api/manage'
// 引入搜索区域弹出框的组件
import areaWindow from '@/views/system/modules/areaWindow'
import areaSelectWindow from '@/views/system/modules/areaSelectWindow'
import echarts from 'echarts/lib/echarts'
import { mapActions, mapGetters } from 'vuex'
import { GetNowDateHMS } from '@/utils/util'
/*
  const jhjgData = [
    { type: '用量', '1月': 0, '2月': 0, '3月': 0, '4月': 0, '5月': 0, '6月': 0, '7月':0, '8月':0,'9月':0 ,'10月':0 ,'11月':0 ,'12月':0 },
    { type: '缴费', '1月': 0, '2月': 0, '3月': 0, '4月': 0, '5月': 0, '6月': 0, '7月':0, '8月':0,'9月':0 ,'10月':0 ,'11月':0 ,'12月':0 }
  ]
  */
const jhjgFields = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
/*
  const jhjgnData = [
    { type: '居民用水', '1月': 0, '2月': 0, '3月': 0, '4月': 0, '5月': 0, '6月': 0, '7月':0, '8月':0,'9月':0 ,'10月':0 ,'11月':0 ,'12月':0 },
    { type: '商业用水', '1月': 0, '2月': 0, '3月': 0, '4月': 0, '5月': 0, '6月': 0, '7月':0, '8月':0,'9月':0 ,'10月':0 ,'11月':0 ,'12月':0 },
    { type: '特殊用水', '1月': 0, '2月': 0, '3月': 0, '4月': 0, '5月': 0, '6月': 0, '7月':0, '8月':0,'9月':0 ,'10月':0 ,'11月':0 ,'12月':0 },
    { type: '其他用水', '1月': 0, '2月': 0, '3月': 0, '4月': 0, '5月': 0, '6月': 0, '7月':0, '8月':0,'9月':0 ,'10月':0 ,'11月':0 ,'12月':0 },
    { type: '绿化用水', '1月': 0, '2月': 0, '3月': 0, '4月': 0, '5月': 0, '6月': 0, '7月':0, '8月':0,'9月':0 ,'10月':0 ,'11月':0 ,'12月':0 }
  ]
  */
/*
  const jhjgnFields=[
    '1月','2月','3月','4月','5月','6月', 
  ]
  */
/*
  const areaFields=[
    '雁塔区','高新区','鄂邑区','莲湖区','灞桥区'
  ]
  const areaData=[
    {type: '1月' , 雁塔区:0,高新区:0,鄂邑区:0,莲湖区:0,灞桥区:0},
    {type: '2月' , 雁塔区:0,高新区:0,鄂邑区:0,莲湖区:0,灞桥区:0},
    {type: '3月' , 雁塔区:0,高新区:0,鄂邑区:0,莲湖区:0,灞桥区:0},
    {type: '4月' , 雁塔区:0,高新区:0,鄂邑区:0,莲湖区:0,灞桥区:0},
    {type: '5月' , 雁塔区:0,高新区:0,鄂邑区:0,莲湖区:0,灞桥区:0},
    {type: '6月' , 雁塔区:0,高新区:0,鄂邑区:0,莲湖区:0,灞桥区:0},
    {type: '7月' , 雁塔区:0,高新区:0,鄂邑区:0,莲湖区:0,灞桥区:0},
    {type: '8月' , 雁塔区:0,高新区:0,鄂邑区:0,莲湖区:0,灞桥区:0},
    {type: '9月' , 雁塔区:0,高新区:0,鄂邑区:0,莲湖区:0,灞桥区:0},
    {type: '10月' , 雁塔区:0,高新区:0,鄂邑区:0,莲湖区:0,灞桥区:0},
    {type: '11月' , 雁塔区:0,高新区:0,鄂邑区:0,莲湖区:0,灞桥区:0},
    {type: '12月' , 雁塔区:0,高新区:0,鄂邑区:0,莲湖区:0,灞桥区:0},
  ]
  */
const DayPieFields = ['昨日', '今日']
const MonthPieFields = ['上月', '本月']
const rankList = []
for (let i = 0; i < 7; i++) {
  rankList.push({
    name: '白鹭岛 ' + (i + 1) + ' 号店',
    total: 1234.56 - i * 100,
  })
}
const barData = []
for (let i = 0; i < 12; i += 1) {
  barData.push({
    x: `${i + 1}月`,
    y: Math.floor(Math.random() * 1000) + 200,
  })
}
export default {
  name: 'IndexChart',
  components: {
    ATooltip,
    ACol,
    ChartCard,
    MiniArea,
    MiniBar,
    MiniProgress,
    RankList,
    Bar,
    Trend,
    LineChartMultid,
    HeadInfo,

    BarMultid,
    Pie,
    areaWindow,
    areaSelectWindow,
  },
  data() {
    return {
      jhjgData: [],
      jhjgFields,
      jhjgnData: [],
      jhjgnFields: [],
      DayPieFields,
      MonthPieFields,
      areaWaterUse: [],
      areaFields: [],
      loading: true,
      center: null,
      rankList,
      barData,
      loginfo: {},
      DayPayData: {
        curDayPayCount: 0,
        curDayPaySum: 0,
        yesterdayPayCount: 0,
        yesterdayPaySum: 0,
      },
      MonthPayData: {
        curMonthPayCount: 0,
        curMonthPaySum: 0,
        lastMonthPayCount: 0,
        lastMonthPaySum: 0,
      },

      // visitFields:['ip','visit','ip2','visit5'],
      // visitInfo:[],
      //indicator: <a-icon type="loading" style="font-size: 24px" spin />,
      url: {
        areaWaterUse: '/jeecg-charge/meter/waterAnalysis/areaWaterUse',
        payMoneyCount: '/jeecg-charge/meter/waterAnalysis/payMoneyCount',
        waterTypeWaterUse: '/jeecg-charge/meter/waterAnalysis/waterTypeWaterUse',
        waterUseAndPay: '/jeecg-charge/meter/waterAnalysis/waterUseAndPay',
        waterUseAnaly: '/jeecg-charge/meter/waterAnalysis/waterUse',
        upPercent: '/jeecg-charge/meter/waterAnalysis/meterReportingRate',
        deviceCount: '/jeecg-charge/meter/waterAnalysis/deviceCount',
        meterFaultCount: '/jeecg-charge/meter/waterAnalysis/meterFaultCount',
      },
      useList: {
        userCountNoFlow: 0,
        waterUseYear: 0,
        waterUseYesterday: 0,
        waterUseYesterdayPercent: 0,
        waterUseCurMonth: 0,
        waterUseLastMonth: 0,
      },
      upPercent: {
        threeUpPercent: 100,
        sevenUpPercent: 100,
      },
      fkStatusTotal: {
        meterValveOpenCount: 0,
        meterValveCloseCount: 0,
      },
      deviceCount: { totalMeterCount: 0, yesterdayAddMeterCount: 0, addMeterCount: 0 },
      meterInfo: {
        meterTotalCount: 0,
        meterBatteryFaultCount: 0,
        meterMagicFaultCount: 0,
        meterValveFaultCount: 0,
        meterFaultPercent: 0,
      },
      option: {},
      option2: {},
      option3: {},
      checkedAreaKeys: [],
      halfCheckedAreaKeys: [],
      checkedAreaNameString: '',
      checkedTopAreaName: '',
      checkedTopAreaKey: null,
      checkedAreaNames: [],
      lineData: {
        monthStrList: [],
        payMoneyList: [],
        waterUseList: [],
      },
      option4: {},
      option5: {},
      updateTime: '',
      cardBodyStyle: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' },
    }
  },
  created() {
    setTimeout(() => {
      this.loading = !this.loading
    }, 1000)
    this.initLogInfo()
  },
  mounted() {
    setTimeout(() => {
      this.init()
    }, 800)
  },
  computed: {
    ...mapGetters({
      areaList: 'areaList',
    }),
  },
  methods: {
    refreshAll() {
      // 全部刷新结果
      this.lineData = this.$options.data.call(this).lineData
      this.deviceCount = this.$options.data.call(this).deviceCount
      this.meterInfo = this.$options.data.call(this).meterInfo
      this.DayPayData = this.$options.data.call(this).DayPayData
      this.MonthPayData = this.$options.data.call(this).MonthPayData
      this.areaWaterUse = this.$options.data.call(this).areaWaterUse
      this.useList = this.$options.data.call(this).useList
      this.fkStatusTotal = this.$options.data.call(this).fkStatusTotal
      this.upPercent = this.$options.data.call(this).upPercent
      this.option4 = {}
      this.option5 = {}
      this.option3 = {}
      this.init()
    },
    initLogInfo() {
      getLoginfo(null).then((res) => {
        if (res.success) {
          Object.keys(res.result).forEach((key) => {
            res.result[key] = res.result[key] + ''
          })
          this.loginfo = res.result
        }
      })
      getVisitInfo().then((res) => {
        if (res.success) {
          this.visitInfo = res.result
        }
      })
    },
    init() {
      this.updateTime = GetNowDateHMS()
      this.queryWaterUseAndPay()
      this.queryDeviceCount()
      this.queryPayMoneyCount()
      this.queryAreaWaterUse()
      this.querywaterUseTotal()
      this.queryDeviceAnasis()
      this.queryMeterFaultCount()
    },
    // 近一年各区域用水统计
    queryAreaWaterUse() {
      this.areaWaterUse = []
      putAction(this.url.areaWaterUse, { areaId: this.checkedTopAreaKey }).then((res) => {
        if (res.success) {
          /*
            this.areaFields = res.result.areaStrList
            let areaStrList = res.result.areaStrList
            let monthStrList = res.result.monthStrList
            let waterUseList = res.result.waterUseList
            for(let i =0;i<monthStrList.length;i++) {
              let useObj = {type: monthStrList[i]}
              for(let j =0;j<areaStrList.length;j++) {
                useObj[areaStrList[j]] = waterUseList[j][i]
              }
              this.areaData[i] = useObj
            }
              */
          this.areaWaterUse = res.result
          let data = this.areaWaterUse.waterUseList.slice(0, 10)
          let category = this.areaWaterUse.areaStrList.slice(0, 10)
          this.checkedAreaKeys = this.areaWaterUse.areaIdList.slice(0, 10)
          this.checkedAreaNames = category
          this.checkedAreaNameString = category.join(',')
          let xAxisData = this.areaWaterUse.monthStrList
          this.setOption3(data, category, xAxisData)
        }
      })
    },
    // 营收分析
    queryPayMoneyCount() {
      /*
        this.$nextTick(()=> {
          this.$refs.option.showLoading('default',{
            maskColor: 'rgba(0,0,0,0.3)',
            color: '#6ED9F2',
            text: ''
          })
          this.$refs.option2.showLoading('default',{
            maskColor: 'rgba(0,0,0,0.3)',
            color: '#6ED9F2',
            text: ''
          })
        })
        */
      putAction(this.url.payMoneyCount, { areaId: this.checkedTopAreaKey }).then((res) => {
        if (res.success) {
          this.DayPayData = {
            curDayPayCount: res.result.curDayCount,
            curDayPaySum: res.result.curDayPay,
            yesterdayPayCount: res.result.yesterdayCount,
            yesterdayPaySum: res.result.yesterdayPay,
          }
          this.MonthPayData = {
            curMonthPayCount: res.result.curMonthCount,
            curMonthPaySum: res.result.curMonthPay,
            lastMonthPayCount: res.result.lastMonthCount,
            lastMonthPaySum: res.result.lastMonthPay,
          }
          //this.setOption(res.result.yesterdayPay,res.result.curDayPay)
          //this.setOption2(res.result.lastMonthPay,res.result.curMonthPay)
        }
      })
    },
    // 各类用户近半年用水统计
    /*
      queryDeviceCount() {
        this.jhjgnData = []
        putAction(this.url.waterTypeWaterUse, {}).then((res) => {
          if(res.success){
            this.jhjgnFields = res.result.monthStrList
            let monthStrList = res.result.monthStrList
            let waterUseList = res.result.waterUseList
            let waterTypeNameList = res.result.waterTypeNameList
            
            for(let i = 0;i<waterTypeNameList.length;i++) {
              let useObj = {}
              useObj['type'] = waterTypeNameList[i]
              for(let j =0; j< monthStrList.length;j++) {
                useObj[monthStrList[j]] = waterUseList[i][j]
              }
              this.jhjgnData[i] = useObj
            }
            console.log(this.jhjgnData)
          }
        })
      },
      */
    // 近一年月用水/ 缴费统计
    queryWaterUseAndPay() {
      putAction(this.url.waterUseAndPay, { areaId: this.checkedTopAreaKey }).then((res) => {
        if (res.success) {
          /*
            let monthStrList = res.result.monthStrList
            let payMoneyList = res.result.payMoneyList
            let waterUseList = res.result.waterUseList
            let useObj = {}
            let payObj = {}
            for(let i =0;i< res.result.monthStrList.length;i++) {
              useObj[monthStrList[i]] = waterUseList[i]
              payObj[monthStrList[i]] = payMoneyList[i]
            }
            this.jhjgData = [{type: '用量',...useObj},{type: '缴费',...payObj}]
            this.jhjgFields = monthStrList
            */
          this.lineData.monthStrList = res.result.monthStrList
          this.lineData.payMoneyList = res.result.payMoneyList
          this.lineData.waterUseList = res.result.waterUseList
          this.setOption4()
          this.setOption5()
        }
      })
    },
    querywaterUseTotal() {
      putAction(this.url.waterUseAnaly, { areaId: this.checkedTopAreaKey }).then((res) => {
        if (res.success) {
          this.useList = res.result
          this.useList.waterUseYesterdayPercent = Number(res.result.waterUseYesterdayPercent)
        }
      })
    },
    queryDeviceAnasis() {
      putAction(this.url.upPercent, { areaId: this.checkedTopAreaKey }).then((res) => {
        if (res.success) {
          this.fkStatusTotal.meterValveOpenCount = res.result.meterValveOpenCount
          this.fkStatusTotal.meterValveCloseCount = res.result.meterValveCloseCount
          if (res.result.meterTotalCount > 0) {
            this.upPercent.threeUpPercent = Number(
              ((res.result.lastThreeDayMeterReportCount / res.result.meterTotalCount) * 100).toFixed(0)
            )
            this.upPercent.sevenUpPercent = Number(
              ((res.result.lastSevenDayMeterReportCount / res.result.meterTotalCount) * 100).toFixed(0)
            )
          }
        }
      })
    },
    queryDeviceCount() {
      putAction(this.url.deviceCount, { areaId: this.checkedTopAreaKey }).then((res) => {
        if (res.success) {
          this.deviceCount = res.result
        }
      })
    },
    queryMeterFaultCount() {
      putAction(this.url.meterFaultCount, { areaId: this.checkedTopAreaKey }).then((res) => {
        if (res.success) {
          console.log(res)
          this.meterInfo.meterTotalCount = res.result.meterTotalCount
          this.meterInfo.meterBatteryFaultCount = res.result.meterBatteryFaultCount
          this.meterInfo.meterMagicFaultCount = res.result.meterMagicFaultCount
          this.meterInfo.meterValveFaultCount = res.result.meterValveFaultCount
          this.meterInfo.meterFaultPercent =
            res.result.meterTotalCount == 0
              ? 0
              : Number(((res.result.meterFaultCount / res.result.meterTotalCount) * 100).toFixed(0))
          console.log(this.meterInfo.meterFaultPercent)
        }
      })
    },
    // 表具异常页面跳转
    skipMeterAbnormalPage(flag) {
      /*
        let faultType = []
        if(flag == 1) {
          // 欠压数
          faultType = [3]
        }else if(flag == 2) {
          // 磁干扰数
          faultType = [6]
        }else if(flag == 3) {
          // 阀门故障数
          faultType = [8]
        }if(flag == 0) {
          // 全部故障
          faultType = [1,2,3,6,8]
        }
        this.$router.push({ 
          name: "MeterReadingAbnormalList",
          params:{
            faultType: faultType
          }
        })
        */
      // 2023-03-10魏凡提出这块的跳转改为实时异常查询页面
      let faultType = null
      if (flag == 1) {
        // 欠压数
        faultType = 1
      } else if (flag == 2) {
        // 磁干扰数
        faultType = 2
      } else if (flag == 3) {
        // 阀门故障数
        faultType = 5
      }
      if (flag == 0) {
      }
      let params = {
        meterWarnType: faultType + '',
      }
      if (this.checkedTopAreaKey != null && this.checkedTopAreaKey != '') {
        params.areaId = this.checkedTopAreaKey
        params.userAreaId = this.checkedTopAreaKey
        params.areaSelected = {
          key: this.checkedTopAreaKey,
          title: this.checkedTopAreaName,
        }
      }
      this.$router.push({
        name: 'MeterReadingAbnormalLastList',
        params: params,
      })
    },
    setOption(yesterdayPay, curDayPay) {
      let seriesData = []
      let data = [yesterdayPay, curDayPay]
      let category = ['昨日', '今日']
      for (let i = 0; i < data.length; i++) {
        seriesData.push({
          name: category[i],
          value: data[i],
        })
      }
      //this.$refs.option.hideLoading()
      this.option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: '#CEE2FF',
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#019AF3',
            },
          },
        },
        title: {
          text: '日',
          textStyle: {
            color: '#52C4DF',
            fontSize: 24,
            fontWeight: 500,
          },
          left: 'center',
          top: '40%',
        },
        legend: {
          orient: 'vertical',
          bottom: 40,
          data: category,
          itemGap: 2,
          icon: 'circle',
          itemHeight: 10,
          formatter: function (name) {
            for (let i = 0; i < category.length; i++) {
              if (category[i] == name) {
                return name + ' {ld|' + data[i] + '}' + '元'
              }
            }
            return name
          },
          textStyle: {
            rich: {
              ld: {
                fontFamily: 'ds-digital-bold',
                fontSize: 18,
                color: '#52C4DF',
              },
              normal: {
                color: '#CEE2FF',
              },
            },
          },
        },

        color: ['#0067FF', '#00CADF'],
        series: [
          {
            name: '营收',
            type: 'pie',
            center: ['50%', '40%'],
            radius: ['60%', '70%'],
            avoidLabelOverlap: false,
            startAngle: 270,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: false,
                fontSize: '30',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: seriesData,
            roundCap: 1, //可选项为1和2，不填则采用原有拼接方式
            animationDelay: 1000,
            animationDuration: 2000,
          },
          {
            name: '',
            type: 'pie',
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            center: ['50%', '40%'],
            radius: ['50%', '52%'],
            tooltip: {
              show: false,
            },
            label: {
              normal: {
                show: false,
              },
            },
            itemStyle: {
              color: '#50E3C2',
              opacity: 0.4,
            },
            data: [100],
          },
        ],
      }
    },
    setOption2(lastMonthPay, curMonthPay) {
      let seriesData = []
      let data = [lastMonthPay, curMonthPay]
      let category = ['上月', '本月']
      for (let i = 0; i < data.length; i++) {
        seriesData.push({
          name: category[i],
          value: data[i],
        })
      }
      //this.$refs.option2.hideLoading()
      this.option2 = {
        title: {
          text: '月',
          textStyle: {
            color: '#52C4DF',
            fontSize: 24,
            fontWeight: 500,
          },
          left: 'center',
          top: '40%',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: '#CEE2FF',
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#019AF3',
            },
          },
        },
        legend: {
          orient: 'vertical',
          bottom: 40,
          data: category,
          itemGap: 1,
          icon: 'circle',
          itemHeight: 10,
          formatter: function (name) {
            for (let i = 0; i < category.length; i++) {
              if (category[i] == name) {
                return name + ' {ld|' + data[i] + '}' + '元'
              }
            }
            return name
          },
          textStyle: {
            rich: {
              ld: {
                fontFamily: 'ds-digital-bold',
                fontSize: 18,
                color: '#52C4DF',
              },
              normal: {
                color: '#CEE2FF',
              },
            },
          },
        },
        color: ['#7CC928', '#FECA20'],
        series: [
          {
            name: '营收',
            type: 'pie',
            radius: ['60%', '70%'],
            center: ['50%', '40%'],
            avoidLabelOverlap: false,
            startAngle: 270,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: false,
                fontSize: '30',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            animationDelay: 1000,
            animationDuration: 2000,
            data: seriesData,
            roundCap: 1, //可选项为1和2，不填则采用原有拼接方式
          },
          {
            name: '',
            type: 'pie',
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            center: ['50%', '40%'],
            radius: ['50%', '52%'],
            tooltip: {
              show: false,
            },
            label: {
              normal: {
                show: false,
              },
            },
            itemStyle: {
              color: '#50E3C2',
            },
            data: [100],
          },
        ],
      }
    },
    legendselectchanged(params) {
      /*
          this.checkedAreaKeys = []
          this.checkedAreaNameString = ''
          this.checkedAreaNames = []
          let strObj = params.selected
          for(let key in strObj) {
            if(strObj[key]) {
              let index = this.areaWaterUse.areaStrList.indexOf(key)
              if(index>-1){
                this.checkedAreaNames.push(key)
                this.checkedAreaKeys.push(this.areaWaterUse.areaIdList[index])
              }
            }
          }
          this.checkedAreaNameString = this.checkedAreaNames.join(',')
          */
    },
    setOption3(data, category, xAxisData) {
      let seriesData = []
      //let selected_item = {}
      for (let i = 0; i < data.length; i++) {
        seriesData.push({
          name: category[i],
          type: 'line',
          //smooth: true,
          symbol: 'circle',
          showSymbol: false,
          animationDelay: i * 100,
          animationDuration: 2000,
          data: data[i],
        })
        /*
                if(selectedAreaData.includes(category[i])) {
                  selected_item[category[i]] = true
                }else{
                  selected_item[category[i]] = false
                }
                */
      }
      //this.$refs.option3.hideLoading()
      this.option3 = {
        color: [
          '#FECA20',
          '#50E3C2',
          '#32C5FF',
          '#0091FF',
          '#0394FF',
          '#4634FA',
          '#0C2D82',
          '#B620E0',
          '#F7B500',
          '#FA6400',
          '#E02020',
        ],
        title: {
          show: false,
        },
        tooltip: {
          trigger: 'axis',
          //backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            // color: '#CEE2FF',
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#019AF3',
            },
          },
        },
        legend: {
          type: 'scroll',
          data: category,
          textStyle: {
            //color: '#CEE2FF'
          },
          icon: 'roundRect',
          itemHeight: 10,
          right: '5%',
          bottom: 5,
          pageTextStyle: {
            //color: 'rgb(91, 135, 195)'
          },
          //selected: selected_item
        },
        grid: {
          left: '0%',
          right: '2%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: xAxisData,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: {
            //color: '#CEE2FF',
            fontSize: 10,
          },
        },
        yAxis: {
          type: 'value',
          name: this.$t('用量(m³)'),
          nameTextStyle: {
            //color: '#CEE2FF',
            // /align: 'right'
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: ['rgba(0,0,0,0.1)']
            }
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: {
            //color: '#CEE2FF',
            fontSize: 10,
          },
        },
        series: seriesData,
      }
    },
    legendToggleSelect(params) {
      console.log('切换了')
    },
    onSearchArea() {
      this.loadTree().then((res) => {
        this.areaTree = res
        this.$refs.areaWindow.add(
          this.checkedAreaKeys,
          this.halfCheckedAreaKeys,
          this.areaTree,
          this.checkedAreaNames,
          this.userId
        )
      })
    },
    onSearchTopArea() {
      this.$refs.areaSelectWindow.add(this.checkedTopAreaKey, this.checkedTopAreaName)
    },
    modalAreaFormOk(formData) {
      this.checkedAreaNames = formData.areaNameList
      this.checkedAreaNameString = this.checkedAreaNames.join(',')
      this.checkedAreaKeys = formData.checkedKeys
      this.halfCheckedAreaKeys = formData.halfCheckedKeys
      let category = this.checkedAreaNames
      let data = []
      let areaNameList = []
      let length = this.checkedAreaNames.length
      for (let i = 0; i < length; i++) {
        let index = this.areaWaterUse.areaStrList.findIndex((val) => {
          return val === this.checkedAreaNames[i]
        })
        if (index > -1) {
          data.push(this.areaWaterUse.waterUseList[index])
          areaNameList.push(this.checkedAreaNames[i])
        }
      }
      let xAxisData = this.areaWaterUse.monthStrList
      this.setOption3(data, areaNameList, xAxisData)
    },
    modalAreaSelectFormOk(formData) {
      this.checkedTopAreaName = formData.currentNodeName
      this.checkedTopAreaKey = formData.currentNodeKey
      this.refreshAll()
    },
    ...mapActions(['GetAreaTreeList']),
    loadTree() {
      var that = this
      this.areaLoading = true
      that.areaTree = []
      console.log(this.areaList)
      return new Promise((resolve, reject) => {
        if (this.areaList.length === 0) {
          that
            .GetAreaTreeList()
            .then((res) => {
              if (res.success) {
                //部门全选后，再添加部门，选中数量增多
                let arr = [...res.result]
                resolve(arr)
              }
            })
            .catch((error) => {
              reject(error)
            })
            .finally(() => {
              that.areaLoading = false
            })
        } else {
          let arr = [...this.areaList]
          this.areaLoading = false
          resolve(arr)
        }
      })
    },
    setOption4() {
      let seriesData = []
      let category = [this.$t('用水量')]
      //this.$refs.option4.hideLoading()
      this.option4 = {
        color: [
          '#FECA20',
          '#50E3C2',
          '#32C5FF',
          '#0091FF',
          '#0394FF',
          '#4634FA',
          '#0C2D82',
          '#B620E0',
          '#F7B500',
          '#FA6400',
          '#E02020',
        ],
        title: {
          show: false,
        },
        tooltip: {
          trigger: 'axis',
          //backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 4,
          textStyle: {
            //color: '#CEE2FF',
          },
          axisPointer: {
            type: 'cross',
            lineStyle: {
              color: '#019AF3',
            },
            label: {
              backgroundColor: '#000439',
              color: 'rgb(0, 250, 254)',
            },
            crossStyle: {
              color: 'rgb(0, 250, 254)',
            },
          },
        },
        legend: {
          show: false,
          data: category,
          selectedMode: false,
          textStyle: {
            //color: '#CEE2FF'
          },
          icon: 'circle',
          itemHeight: 10,
          right: '4%',
        },
        grid: {
          left: '0%',
          right: '2%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.lineData.monthStrList,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: {
            //color: '#CEE2FF',
            fontSize: 10,
          },
        },
        yAxis: [
          {
            type: 'value',
            name: this.$t('用量(m³)'),
            nameTextStyle: {
              //color: '#CEE2FF',
              // /align: 'right'
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: ['rgba(0,0,0,0.1)']
              }
              
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
            },
            axisLabel: {
              //color: '#CEE2FF',
              fontSize: 10,
            },
          },
        ],
        series: [
          {
            type: 'bar',
            name: this.$t('用水量'),
            data: this.lineData.waterUseList,
            barMaxWidth: 14,
            animationDuration: 2000,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#00D2FF' },
                  { offset: 1, color: '#3A7BD5' },
                ]),
                //barBorderRadius:20
              },
            },
          },
        ],
      }
    },
    setOption5() {
      let seriesData = []
      let category = [this.$t('缴费')]
      //this.$refs.option4.hideLoading()
      this.option5 = {
        color: [
          '#FECA20',
          '#50E3C2',
          '#32C5FF',
          '#0091FF',
          '#0394FF',
          '#4634FA',
          '#0C2D82',
          '#B620E0',
          '#F7B500',
          '#FA6400',
          '#E02020',
        ],
        title: {
          show: false,
        },
        tooltip: {
          trigger: 'axis',
          //backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 4,
          textStyle: {
            //color: '#CEE2FF',
          },
          axisPointer: {
            type: 'cross',
            lineStyle: {
              color: '#019AF3',
            },
            label: {
              backgroundColor: '#000439',
              color: 'rgb(0, 250, 254)',
            },
            crossStyle: {
              color: 'rgb(0, 250, 254)',
            },
          },
        },
        legend: {
          show: false,
          data: category,
          selectedMode: false,
          textStyle: {
            //color: '#CEE2FF'
          },
          icon: 'circle',
          itemHeight: 10,
          right: '4%',
        },
        grid: {
          left: '0%',
          right: '2%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.lineData.monthStrList,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: {
            //color: '#CEE2FF',
            fontSize: 10,
          },
        },
        yAxis: [
          {
            type: 'value',
            name: this.$t('缴费(元)'),
            nameTextStyle: {
              //color: '#CEE2FF',
              align: 'left',
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: ['rgba(0,0,0,0.1)']
              }
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
            },
            axisLabel: {
              //color: '#CEE2FF',
              fontSize: 10,
            },
          },
        ],
        series: [
          {
            type: 'line',
            //yAxisIndex: 1,
            name: this.$t('缴费'),
            data: this.lineData.payMoneyList,
            smooth: true,
            symbol: 'circle',
            animationDelay: 1000,
            itemStyle: {
              normal: {
                color: '#F5A623',
                borderColor: '#F5A623',
                lineStyle: {
                  color: '#F5A623', //折线的颜色
                },
              },
            },
          },
        ],
      }
    },
  },
}
</script>

<style lang="less" scoped>
.playground {
  background-color: #f2f4f8;
}

.ant-card {
  border-radius: 10px;
}

.card-body-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.info-text {
  height: 14px;
  font-size: 15px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  color: #69737f;
  line-height: 18px;
  text-align: center;
}

.info-num {
  height: 12px;
  font-size: 15px;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  color: #212d40;
  line-height: 18px;
  text-align: center;
}

.start-title {
  text-align: start;
}

.litte-card {
  height: 59px;
  width: 100%;
  background: #f1f3f8;
  border-radius: 3px;
  opacity: 0.7;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.white-center-big {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.white-info {
  height: 15px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 400;
  color: #ffffff;
  line-height: 18px;
  text-align: center;
}

.white-num {
  height: 21px;
  font-size: 28px;
  font-family: Alibaba PuHuiTi;
  font-weight: 800;
  color: #ffffff;
  line-height: 18px;
  text-align: center;
}

.circle-cust {
  position: relative;
  top: 28px;
  left: -100%;
}
.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}

/* 首页访问量统计 */
.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  &.center {
    text-align: center;
    padding: 0 32px;
  }

  span {
    color: rgba(0, 0, 0, 0.45);
    display: inline-block;
    font-size: 0.95rem;
    line-height: 42px;
    margin-bottom: 4px;
  }
  p {
    line-height: 42px;
    margin: 0;
    a {
      font-weight: 600;
      font-size: 1rem;
    }
  }
}
/deep/.total{
  width: auto;
}
</style>
